import React, { useState, useEffect } from "react";
import axios from "axios";
import { CKEditor } from "@ckeditor/ckeditor5-react";
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";
import styles from "../assets/css/TextEditor.module.css";
import { BASE_URL } from "../constants/constants";

const TextEditor = () => {
  const [editorData, setEditorData] = useState("");
  const [loading, setLoading] = useState(false);
  const token = localStorage.getItem("token");

  const headers = {
    Authorization: `Bearer ${token}`,
  };

  useEffect(() => {
    const fetchInfo = async () => {
      try {
        const response = await axios.get(`${BASE_URL}/v0/bonus/info`, { headers });

        if (response.data && response.data.result) {
          setEditorData(response.data.result);
        } else {
          console.warn("Пустой ответ от API");
        }
      } catch (error) {
        console.error("Ошибка загрузки данных:", error);
      }
    };

    fetchInfo();
  }, []);

  const saveData = async () => {
    setLoading(true);
    const cleanedData = editorData.replace(/font-family:[^;"]+;/g, "font-family: Poppins, sans-serif;");

    try {
      console.log("Отправляемые данные:", cleanedData);
      const response = await axios.patch(
        `${BASE_URL}/v0/bonus/info`,
        { infoText: editorData },
        { headers }
      );

      console.log("Данные успешно обновлены:", response.data);
      alert("Данные успешно сохранены!");

      if (response.data && response.data.result) {
        setEditorData(response.data.result);
      }
    } catch (error) {
      console.error("Ошибка при сохранении данных:", error);
      alert("Ошибка при сохранении!");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div>
      <CKEditor
        editor={ClassicEditor}
        config={{
          contentStyle: "font-family: Poppins, sans-serif;", 
        }}
        data={editorData}
        onReady={(editor) => {
          editor.editing.view.change((writer) => {
            writer.setStyle(
              "background-color",
              "#fff",
              editor.editing.view.document.getRoot()
            );
            writer.setStyle(
              "min-height",
              "300px",
              editor.editing.view.document.getRoot()
            );
          });
        }}
        onChange={(event, editor) => {
          setEditorData(editor.getData());
        }}
        onError={(error) => {
          console.error("CKEditor Error:", error);
        }}
      />
      <div className={styles.buttonWrapper}>
        <button className={styles.button} onClick={saveData} disabled={loading}>
          {loading ? "Сохранение..." : "Сохранить"}
        </button>
      </div>
    </div>
  );
};

export default TextEditor;
